import { apiGet, apiPost, apiClient } from "../lib/api-client";
import {
  fetchEmailPreferences as sharedFetch,
  updateEmailPreferences as sharedUpdate,
  type EmailPreferencesPatch,
  type EmailPreferencesResponse,
} from "@atlas/shared";

// ─── Account email preferences (spec 16) ─────────────────────────────────────

export const EMAIL_PREFERENCES_KEY = ["account/email-preferences"];

export function fetchEmailPreferences(): Promise<EmailPreferencesResponse> {
  return sharedFetch(apiClient);
}

export function updateEmailPreferences(patch: EmailPreferencesPatch): Promise<EmailPreferencesResponse> {
  return sharedUpdate(apiClient, patch);
}

// ─── Admin ───────────────────────────────────────────────────────────────────

export interface AdminEmailKindRow {
  kind: string;
  status: string;
  last7d: number;
  last30d: number;
}

export interface AdminEmailSummary {
  sent7d: number;
  sent30d: number;
  failed7d: number;
  failed30d: number;
  skipped30d: number;
  pendingImportMarkers: number;
  byKind: AdminEmailKindRow[];
  optOuts: {
    totalUsers: number;
    activity: { count: number; pct: number };
    digest: { count: number; pct: number };
    product: { count: number; pct: number };
  };
}

export function fetchAdminEmailSummary(): Promise<{ summary: AdminEmailSummary }> {
  return apiGet("/admin/emails/summary");
}

export interface AdminEmailLogEntry {
  id: string;
  userId: string | null;
  toEmail: string;
  userName: string | null;
  kind: string;
  category: string;
  subject: string;
  status: string;
  error: string | null;
  meta: Record<string, unknown>;
  dedupeKey: string | null;
  createdAt: string;
}

export interface AdminEmailLogQuery {
  kind?: string;
  status?: string;
  q?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

export function fetchAdminEmailLog(
  q: AdminEmailLogQuery = {},
): Promise<{ entries: AdminEmailLogEntry[]; total: number; limit: number; offset: number }> {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v !== undefined && v !== "" && v !== null) params.set(k, String(v));
  }
  const qs = params.toString();
  return apiGet(`/admin/emails/log${qs ? `?${qs}` : ""}`);
}

export function fetchAdminUserEmails(userId: string): Promise<{
  preferences: { activity: boolean; digest: boolean; product: boolean };
  entries: Array<Pick<AdminEmailLogEntry, "id" | "kind" | "category" | "subject" | "status" | "error" | "meta" | "createdAt">>;
}> {
  return apiGet(`/admin/emails/users/${userId}`);
}

export function sendAdminTestEmail(kind: string): Promise<{ ok: boolean; queued: boolean; to: string }> {
  return apiPost("/admin/emails/test", { kind });
}

